<template>
    <div class="panel">
        <transition name="fade" appear>
            <img :src="require('@/assets/images/panel_graphics/social.png')" alt="">
        </transition>
    </div>
</template>

<script>

    export default {
        name: 'Social_panel',
        created: function () {
            CodeBaby.jQuery('.no-nlp:hidden').show();
            CodeBaby.jQuery('.codebaby-stt-button:hidden').show();
        }
    }
</script>
<style scoped lang="stylus">
.panel
    background: none !important
.fade-enter-active, .fade-leave-active 
    transition: opacity 1s
.fade-enter, .fade-leave-to
    opacity: 0
</style>